import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SelectActionsPage } from './select-actions.page';

const routes: Routes = [
  {
    path: '',
    component: SelectActionsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SelectActionsPageRoutingModule {}
